
<p *ngIf="showSecurityMsg" class="info-message">{{locale.LABEL_OPEN_API_SECURITY_MSG}}</p>

<div class="container mock-server-card" *ngIf="!apiService.mockServerIntroDone && !isMockEnabled && preferences.project.mockserver?.view">
  <button aria-label="Close" class="close" (click)="closeCreateMockServerCard()" title="Close">
    <span aria-hidden="true">&times;</span>
  </button>
  <h4>{{locale.LABEL_MOCK_API}}</h4>
  <div class="mock-server-img">
    <img [src]="('assets/launch-mock-server.svg' | versionManager)" alt="" />
  </div>
  <div class="mock-server-desc">
    <label>{{locale.MESSAGE_MOCK_API_DESCRIPTION}}</label>
    <a target="_blank" href="https://docs.wavemaker.com/learn/app-development/services/mock-services/mock-imported-apis">{{locale.LABEL_KNOW_MORE}}</a>
  </div>
  <button type="button" class="btn btn-md btn-primary" (click)="openMockServerProgressDialog()">{{locale.BUTTON_CREATE_MOCK_SERVER}}</button>
</div>

<div class="container mock-data-toggle" [ngClass]="{'on': isMockEnabled, 'off': !isMockEnabled}" *ngIf="(apiService.mockServerIntroDone || isMockEnabled) && preferences.project.mockserver?.view">
  <label class="col-md-3">{{locale.LABEL_USE_MOCK_DATA}}</label>
  <div class="col-md-3">
    <div class="custom-toggle"
         [ngClass]="{'on': isMockEnabled}"
         (click)="updateMockServerStatus()">
      <label></label>
    </div>
  </div>
  <div class="col-md-6">
    <div class="mock-data-in-use" *ngIf="isMockEnabled">
      <i class="wi wi-info-outline"></i>
      <label>{{locale.MESSAGE_MOCK_DATA_BEING_USED}}</label>
    </div>
    <a class="know-more" target="_blank" href="https://docs.wavemaker.com/learn/app-development/services/mock-services/mock-imported-apis">{{locale.LABEL_KNOW_MORE}}</a>
  </div>
</div>

<div class="container settings">
  <form class="wm-form">
    <ul class="row category-section ng-scope">
      <li class="security">
        <div class="security-name"><h5>{{locale.LABEL_BASIC_CONFIG}}</h5></div>
        <ul class="security-properties">
          <li class="security-property general">
            <div class="col-xs-12 form-group">
              <label class="col-xs-3">{{locale.LABEL_HOST_NAME}}</label>
              <div class="col-xs-9">
                <input name="input-host-name" class="form-control" type="text" [ngModel]="apiService.config && apiService.config.host" (ngModelChange)="apiService.config && (apiService.config.host = $event)" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
          </li>
          <li class="security-property general">
            <div class="col-xs-12 form-group">
              <label class="col-xs-3">{{locale.LABEL_BASE_PATH}}</label>
              <div class="col-xs-9">
                <input name="input-base-path" class="form-control" type="text" [ngModel]="apiService.config && apiService.config.basePath" (ngModelChange)="apiService.config && (apiService.config.basePath = $event)" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
          </li>
          <li class="security-property general">
            <div class="col-xs-12 form-group">
              <label class="control-label app-label col-xs-3 pt-5" for="rest-use-proxy">{{locale.LABEL_WEB_SERVICE_USE_PROXY}}</label>
              <div class="col-md-3">
                <wms-toggle name="wm-webservice-use-proxy" id="rest-use-proxy" [hideLabels]=true (onChange)="useProxyToggle($event)"  [onValue]="true" [offValue]="false"
                            [model]="apiService.config?.useProxy"   title="{{apiService.config && apiService.config.disableUseProxy ? locale.MSG_HELP_DISABLE_USE_PROXY : ''}}"></wms-toggle>
                <i placement="right" [tooltipAppendToBody]="true" [tooltip]="proxyTooltipMsg"
                   class="wms wms-help ml-10"></i>
              </div>
              <div class="col-md-6" *ngIf="!apiService.config?.useProxy">
                <label class="control-label app-label col-md-7 pt-5" for="rest-with-credentials">{{locale.LABEL_WEB_SERVICE_WITH_CREDENTIALS}}</label>
                <wms-toggle name="wm-webservice-with-credentials" id="rest-with-credentials" [hideLabels]=true (onChange)="useCredentialsToggle($event)"
                            [model]="apiService.config && apiService.config.withCredentials" [onValue]="true" [offValue]="false"></wms-toggle>
                <i placement="right" [tooltipAppendToBody]="true" tooltip={{locale.MESSAGE_HELP_WITH_CREDENTIALS}}
                   class="wms wms-help ml-10"></i>
              </div>
            </div>
          </li>
        </ul>
      </li>
    </ul>

    <h5 class="mt-10" (click)="onClickSecurityConfiguration()" *ngIf="apiService.config?.securityConfigs.length">
			<span class="authorizations-heading">
				<i class="wms" [ngClass]="{'wms-caret-right': !showSecurityConfig, 'wms-caret-down': showSecurityConfig}"></i>
				<span>{{locale.LABEL_AVAILABLE_AUTHORIZATIONS}}</span>
			</span>
    </h5>
    <ul class="row category-section ng-scope" *ngFor="let definition of apiService.config?.securityConfigs">
      <li class="security" *ngIf="showSecurityConfig && apiService.config">
        <div class="security-name">
          <h5>{{definition.key}} ({{definition.type}})</h5>
        </div>
        <!-- API KEY -->
        <ul class="security-properties" *ngIf="definition.type ==='API_KEY'">
          <li class="security-property general">
            <div class="col-xs-3">
              <label class="control-label app-label">{{locale.LABEL_NAME}}</label>
            </div>
            <div class="col-xs-4">
              <label class="control-label app-label">{{definition.name}}</label>
            </div>
          </li>
          <li class="security-property general">
            <div class="col-xs-3">
              <label class="control-label app-label">{{locale.LABEL_IN}}</label>
            </div>
            <div class="col-xs-4">
              <label class="control-label app-label">{{definition.in}}</label>
            </div>
          </li>
          <li class="security-property general form-group">
            <div class="col-xs-3">
              <label class="control-label app-label">{{locale.LABEL_VALUE}}</label>
            </div>
            <div class="col-xs-9">
              <input class="form-control app-text" type="text" [(ngModel)]="definition.value" [ngModelOptions]="{standalone: true}">
            </div>
          </li>
        </ul>
        <!--OAUTH-->
        <ul class="security-properties" *ngIf="definition.type ==='OAUTH'">
          <li class="security-property general form-group">
            <div class="col-xs-3">
              <label class="control-label app-label">
                {{locale.LABEL_HTTP_AUTHENTICATION_PROVIDER_OAUTH}}
              </label>
            </div>
            <div class="col-xs-9">
              <input class="form-control" readonly="readonly" value="{{definition.providerId}}"/>
              <button class="btn btn-transparent" (click)="openOauthProviderConfigDialog(definition.providerId)" title="{{locale.ICONTITLE_EDIT_PROVIDER}}">
                <i class="wms wms-edit"></i>
              </button>
            </div>
          </li>
        </ul>
      </li>
    </ul>
    <div class="form-group text-right save-btn">
      <button type="submit" class="btn btn-md btn-primary" (click)="saveSecurityConfiguration()">
        {{locale.LABEL_SAVE}}
      </button>
    </div>
  </form>
</div>


<wms-dialog id="MockServerInProgressDialog" [content]="OpenMockApi" customClasses="mock-server-in-progress">
</wms-dialog>
<ng-template #OpenMockApi>
    <wms-dialog-body>
    <div><img [src]="('assets/launch-mock-server.svg' | versionManager)" alt="" /></div>
    <label class="col-md-12 create-mock-heading">{{locale.TITLE_LAUNCH_MOCK_API}}</label>
    <div class="indeterminate-spinner"><i></i></div>
    <label class="col-md-12 loading-msg">{{locale.MSG_MOCK_SERVER_CREATION_IN_PROGRESS}}</label>
    </wms-dialog-body>
</ng-template>

<wms-dialog id="MockServerConfirmDialog" [content]="CloseMockApi">
</wms-dialog>
<ng-template #CloseMockApi>
    <wms-dialog-header title="{{locale.TITLE_STOP_MOCK_SERVER}}" (onClose)="closeDialogWithId('MockServerConfirmDialog')">
    </wms-dialog-header>
    <wms-dialog-body><p class="app-dialog-message">{{locale.MESSAGE_STOP_MOCK_SERVER_CONFIRMATION}}</p></wms-dialog-body>
    <wms-dialog-footer>
      <button class="cancel-action btn app-button btn-secondary" (click)="onCancel($event)"><span class="btn-caption">Cancel</span></button>
      <button class="btn-primary ok-action btn app-button" (click)="onOk($event)"><span class="btn-caption">Ok</span></button>
    </wms-dialog-footer>
</ng-template>
<wms-oauth-provider></wms-oauth-provider>
<ng-template #proxyTooltipMsg> <span [innerHtml]="locale.MESSAGE_HELP_USE_PROXY"></span></ng-template>